function AdmissionGroupTypeFilter() {
  return function (admissionGroupType) {
    let type;

    switch (admissionGroupType) {
    case 'TABLE':
      type = 'Table';
      break;
    case 'TICKET':
      type = 'Ticket';
      break;
    case 'GUEST_LIST':
      type = 'Guestlist';
      break;
    case 'PACKAGE':
      type = 'Package';
      break;
    default:
      type = 'Table';
    }

    return type;
  };
}

AdmissionGroupTypeFilter.$inject = [];

export default AdmissionGroupTypeFilter;



// WEBPACK FOOTER //
// ./src/filters/admissionGroupTypeFilter.js